export var darkGrayGradientBackground = '$EvmQP';
export var dquotSurround = 'AgObi';
export var lightGrayGradientBackground = '$o-8Pn';
export var placeholderColor = '$h6nZs';
export var textShadow = 'ysvGQ';
export var transparentBlackGradientBackground = 'nrl6y';
export var verticallyCenter = 'd-Ng9';